<template>
    <NuxtLayout name="main">
        <section class="bg-no-repeat bg-cover w-[100%] h-[400px] pt-[114px]" :style="`background-image:url('${options.banner.cover}')`">
            <div class="container">
                <div class="text-white text-[56px] leading-[56px] font-bold max-lg:text-[40px] max-lg:leading-[40px]">{{ options.banner.title }}</div>
                <div class="mt-[24px] text-white text-[20px] leading-[36px] max-lg:mt-[16px] max-lg:text-[16px] max-lg:leading-[32px]">
                    {{ options.banner.descript }}
                </div>
            </div>
        </section>
        <section class="container pt-[40px]">
            <div>
                <project-route target="_self" :to="{ name: 'Home' }">{{ $t("Home.Name") }}</project-route> >
                {{ $t("News") }}
            </div>
            <div class="mt-[40px] flex justify-between">
                <div class="flex">
                    <project-route
                        v-for="value in filters"
                        :to="{ name: 'News', params: { type: value.route } }"
                        target="_self"
                        class="whitespace-nowrap mr-[16px] rounded-[4px] px-[24px] py-[9px] !text-default t-delay cursor-pointer hover:bg-main hover:!text-white"
                        :class="filter == value.value ? 'bg-main !text-white' : 'bg-white'">
                        {{ value.label }}
                    </project-route>
                </div>
                <default-search v-model="keyword" size="middle" :width="496" @search="methods.acquire(1)" />
            </div>

            <div v-loading="loading">
                <div class="mt-[48px] flex flex-wrap content-stretch gap-x-[32px] gap-y-[48px]">
                    <project-route
                        target="_blank"
                        :to="{ name: 'NewsDetails', params: value.route }"
                        v-for="value in data"
                        class="flex flex-col group w-[356px] max-xl:w-[308px] max-lg:w-[260px]">
                        <div class="relative rounded-t-[4px] overflow-hidden h-[200px] max-xl:h-[173px] max-lg:h-[146px]">
                            <img class="w-full h-full object-cover" :src="value.cover.src" :alt="value.cover.alt" />
                            <div class="absolute top-0 left-0 w-full h-full p-[20px] max-xl:py-[12px]" v-if="value.labels?.length">
                                <div v-for="_ in value.labels" v-html="_" class="text-white font-bold text-[18px] max-xl:text-[16px]"></div>
                            </div>
                        </div>
                        <div class="flex-1 flex flex-col rounded-b-[4px] p-[20px] t-border-uicolor4 border-r-0 t-delay group-hover:t-border-main">
                            <div class="flex">
                                <div v-if="value.type" class="shrink-0 bg-[#FDF1FF] leading-[32px] px-[8px] rounded-[4px] text-main">
                                    {{ value.type }}
                                </div>
                                <div
                                    v-if="value.author"
                                    class="ml-[8px] bg-[#E7EDFF] leading-[32px] px-[8px] rounded-[4px] text-[#5A90B6] line-clamp-1">
                                    {{ value.author }}
                                </div>
                            </div>
                            <div
                                class="flex-1 mt-[12px] mb-[16px] text-[14px] leading-[28px] font-bold text-emphas line-clamp-2 t-delay group-hover:text-main">
                                {{ value.title }}
                            </div>
                            <div class="flex justify-between">
                                <div class="text-default"><ui-icon name="date2" class="mr-[8px]" />{{ value.date }}</div>
                            </div>
                        </div>
                    </project-route>
                </div>
                <div
                    class="flex items-center justify-center mt-[48px] min-h-[160px] bg-uicolor5 text-emphas text-[16px] font-bold"
                    v-show="!data.length">
                    {{ $t("NoData") }}
                </div>

                <ui-pagination class="mt-[40px]" v-model="page" :count="count" :limit="limit" @change="methods.acquire" v-if="count > limit">
                    <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: limit }) }}</template></ui-pagination
                >
            </div>
        </section>
    </NuxtLayout>
</template>
<script lang="ts" setup>
//* 组件库
import { UiIcon, UiPagination } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";

//* 组合函数
const {
    refs: { loading, page, limit, count, data, filter, keyword },
    methods,
} = useComposable();

//* 获取初始数据
const options = await api.server("News", "/api/news", {
    method: "POST",
    data: {
        type: filter.value,
        limit: limit.value,
    },
    success: (response) => {
        count.value = response.value?.news?.count || 0;
        data.value = response.value?.news?.data || [];
    },
});
const { filters } = options.value;
</script>
